$.extend({
	bindTouch : function (jEl) {
		if (typeof window.tb == 'undefined') {
			window.tb = {};
		}
		window.tb.scrollStartPos = 0;

		jEl.on("touchstart.tb", function (oEvent) {
			window.tb.scrollStartPos = jEl.scrollTop() + oEvent.originalEvent.touches[0].pageY;
			setTimeout(function () {
				oEvent.preventDefault();
			}, 1);
		});
		jEl.on("touchmove.tb", function (oEvent) {
			jEl.scrollTop(window.tb.scrollStartPos - oEvent.originalEvent.touches[0].pageY);
			oEvent.preventDefault();
		});

		return this;
	},
	unbindTouch : function (jEl) {
		if (typeof window.tb == 'undefined') {
			return this;
		}
		window.tb.scrollStartPos = 0;
		jEl.off("touchstart.tb");
		jEl.off("touchmove.tb");

		return this;
	}
});